<div class="header">
  <div class="header-cont">
    <h2>{{ 'map.title' | translate }}</h2>
  </div>
</div>

<div class="section-headers">
  <div class="section-headers-cont">
    <h3>{{ 'map.areas.cimbri' | translate }}</h3>
  </div>
</div>
<div class="single-section margin-small top">
  <div class="section-cont">
    <div class="area">
      <img src="../../../assets/map/cimbri.png" [routerLink]="['/home/aree/' + geopos_url['Cimbri']]"/>
      <p>{{ 'map.descr.cimbri' | translate }}</p>
    </div>
  </div>
</div>

<div class="section-headers">
  <div class="section-headers-cont">
    <h3>{{ 'map.areas.friuli' | translate }}</h3>
  </div>
</div>
<div class="single-section margin-small top">
  <div class="section-cont">
    <div class="area">
      <img src="../../../assets/map/friuli.png" [routerLink]="['/home/aree/' + geopos_url['Friulani in Veneto']]"/>
      <p>{{ 'map.descr.friuli' | translate }}</p>
    </div>
  </div>
</div>

<div class="section-headers">
  <div class="section-headers-cont">
    <h3>{{ 'map.areas.ita_slo' | translate }}</h3>
  </div>
</div>
<div class="single-section margin-small top">
  <div class="section-cont">
    <div class="area">
      <img src="../../../assets/map/ita_slo.png" [routerLink]="['/home/aree/' + geopos_url['Italiani in Slovenia']]"/>
      <p>{{ 'map.descr.ita_slo' | translate }}</p>
    </div>
  </div>
</div>

<div class="section-headers">
  <div class="section-headers-cont">
    <h3>{{ 'map.areas.ladini' | translate }}</h3>
  </div>
</div>
<div class="single-section margin-small top">
  <div class="section-cont">
    <div class="area">
      <img src="../../../assets/map/ladini.png" [routerLink]="['/home/aree/' + geopos_url['Ladini del Comelico']]"/>
      <p>{{ 'map.descr.ladini' | translate }}</p>
    </div>
  </div>
</div>

<div class="section-headers">
  <div class="section-headers-cont">
    <h3>{{ 'map.areas.slo_ita' | translate }}</h3>
  </div>
</div>
<div class="single-section margin-small top">
  <div class="section-cont">
    <div class="area">
      <img src="../../../assets/map/slo_ita.png" [routerLink]="['/home/aree/' + geopos_url['Sloveni in Italia']]"/>
      <p>{{ 'map.descr.slo_ita' | translate }}</p>
    </div>
  </div>
</div>

<div class="section-headers">
  <div class="section-headers-cont">
    <h3>{{ 'map.areas.friuli-fvg' | translate }}</h3>
  </div>
</div>
<div class="single-section margin-small top">
  <div class="section-cont">
    <div class="area">
      <img src="../../../assets/map/friulani_fvg.png" [routerLink]="['/home/aree/' + geopos_url['Friulani in Friuli Venezia Giulia']]"/>
      <p>{{ 'map.descr.friuli-fvg' | translate }}</p>
    </div>
  </div>
</div>
